import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event19 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    IWA Water and Development Congress &amp; Exhibition 2025 - Reflecting on Bangladesh’s

                    Sanitation Journey
                  </h2>



                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    We are proud to share that the CWIS-FSM Support Cell, Department of Public Health
                    Engineering, participated in the IWA Water and Development Congress &amp; Exhibition 2025 held
                    at Queen Sirikit National Convention Center in Bangkok, Thailand, from December 8-12, 2025. A
                    highlight of our participation was the workshop titled &quot;Bangladesh&#39;s Sanitation Journey: &#39;Access
                    to Safe Management&#39; - Challenges, Successes, and Ways Forward&quot;, which took place on
                    Thursday, December 11th, 2025, from 10:30 AM to 12:00 PM.
                  </p>
                  <br />
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    The workshop explored Bangladesh&#39;s progress in sanitation, discussing key initiatives such as
                    Community-Led Total Sanitation (CLTS) and the &quot;Journey to Zero&quot; campaign that helped the
                    country achieve open defecation-free status. Our session highlighted challenges, successes, and
                    the lessons learned that can guide future sanitation strategies worldwide.
                  </p>
                  <br />
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    Dr. Abdullah Al-Muyeed, Chief Operations Officer, CWIS-FSM Support Cell, Department of
                    Public Health Engineering Co-Chaired the workshop and, lead the discussions. He emphasized
                    critical topics such as Faecal Sludge Management (FSM), City-Wide Inclusive Sanitation (CWIS)
                    and Safely Managed Sanitation. Dr. Abdullah Al-Muyeed also highlighted the challenges faced
                    along the way and outlined the key steps forward to ensure continued progress towards
                    achieving safely managed sanitation for all.
                  </p>
                  <br />
                  <p style={{
                    width: "100%",
                    textAlign: "justify",
                    fontSize: "16px",
                    color: "black",
                    padding: "10px 0",
                  }}>The workshop also featured a distinguished panel of experts, including:</p>
                  <ul>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                      marginLeft:'30px'
                    }}>
                      Md. Saiful Islam Mazomder – Joint Secretary, Local Government Division
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                      marginLeft:'30px'
                    }}>
                      Mr. Eheteshamul Russel Khan – Additional Chief Engineer, Department of Public Health
                      Engineering
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                      marginLeft:'30px'
                    }}>
                      Roshan Raj Shrestha – Deputy Director, Gates Foundation
                      Engineering
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                      marginLeft:'30px'
                    }}>
                      Dr. Tanvir Ahmed – Professor, BUET &amp; Regional Director, GSGS South and South-East
                      Regional Hub, Asian Institute of Technology
                      Engineering
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                      marginLeft:'30px'
                    }}>
                      Hasin Jahan – Chair, Country Director, WaterAid Bangladesh
                      Engineering
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                      marginLeft:'30px'
                    }}>
                      Md. Tahmidul Islam – Moderator, Director, Technical Services, WaterAid Bangladesh
                      Engineering
                    </li>
                  </ul>
                  <br />
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    During the session, participants also discussed the highlights from the recent Toilet Conference
                    held in Bangladesh, emphasizing the country’s commitment to SDG 6.2, ensuring access to
                    safely managed sanitation for all.
                  </p>
                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news29/1.jpeg`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height:'550px'
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news29/2.jpeg`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "60%",
                            height: "500px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news29/3.jpeg`}
                          alt="thumb"
                        />
                      </div>
                    </Col>

                  </Row>


                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event19;
